function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.75 1)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  strokeWidth: 0.609,
  d: "M.437 6.594L6.384.53l5.946 6.063"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  cx: 6.349,
  cy: 0.741,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.5 10.143)",
  fill: "#E57373"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.389,
  cy: 1.976,
  rx: 1.918,
  ry: 1.976
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.272,
  cy: 3.002,
  rx: 1.918,
  ry: 1.976
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.272,
  cy: 5.422,
  rx: 1.279,
  ry: 1.317
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.936 7.184h.158c1.069 0 1.935.866 1.935 1.935v2.879H0V9.119C0 8.05.867 7.184 1.936 7.184zM15.871 7.782h.158c1.07 0 1.936.867 1.936 1.936v2.215h-4.03V9.718c0-1.07.867-1.936 1.936-1.936z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.555 4.618h.318A2.58 2.58 0 019.453 7.2v4.89h-5.48v-4.89a2.58 2.58 0 012.582-2.58z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.438 5.644h.318a2.58 2.58 0 012.581 2.581v3.894h-5.48V8.225a2.58 2.58 0 012.581-2.58z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.795,
  cy: 6.106,
  rx: 1.279,
  ry: 1.317
})), /*#__PURE__*/React.createElement("path", {
  d: "M.305 5.305v18.39h25.39V5.305H.305zm2.39 2.39h20.61v13.61H2.695V7.695z",
  stroke: "#371447",
  strokeWidth: 0.609,
  fill: "#E57373"
}));

function SvgFamilySm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFamilySm;